import { render, staticRenderFns } from "./bolum.vue?vue&type=template&id=4406bf57&"
import script from "./bolum.vue?vue&type=script&lang=js&"
export * from "./bolum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports